import { Checkbox, SelectV2Option } from '@cimplico/components';
import { useController, useFormContext } from 'react-hook-form';
import { OnboardingXeroEntities } from './XeroEntitiesForm';
import ExistingEntitiesSelect from './ExistingEntitiesSelect';
import { ArrowRightIcon } from '@heroicons/react/20/solid';

type XeroEntityRowProps = {
    index: number;
    entitiesOptions: SelectV2Option[];
};

function XeroEntityRow({ index, entitiesOptions }: XeroEntityRowProps): JSX.Element {
    const { getValues, formState, setValue } = useFormContext<OnboardingXeroEntities>();

    const selectField = useController({ name: `connections.${index}.isSelected` });
    const connection = getValues(`connections.${index}`);

    function handleSelect(checked: boolean): void {
        selectField.field.onChange(checked);

        if (getValues('connections').every((c) => c.isSelected)) {
            setValue('globalSelected', true);
        } else {
            setValue('globalSelected', false);
        }
    }

    return (
        <div className={`flex items-center gap-3 p-1.5`}>
            <Checkbox
                checked={connection.isSelected}
                disabled={formState.isSubmitting}
                onChange={(e): void => handleSelect(e.target.checked)}
                name={selectField.field.name}
                id={selectField.field.name}
                value={selectField.field.value}
            />
            <div className="w-full items-center grid grid-cols-[45%_10%_45%]">
                <p className="text-sm text-gray-600">{connection.xeroEntity.tenantName}</p>
                <ArrowRightIcon className={`h-5 w-5 text-indigo-600`} />

                <ExistingEntitiesSelect entitiesOptions={entitiesOptions} index={index} />
            </div>
        </div>
    );
}

export default XeroEntityRow;
